// Shared language cookie key. Written on the parent ACT domain (see
// getCookieDomainSafe), so a language chosen in any ACT console — SI, Admin
// Portal, KYC — applies across all of them, matching the SI Console.
export const LANGUAGE_KEY = "language";

export const DEFAULT_LANGUAGE = "en";

export interface LanguageOption {
  value: string;
  label: string;
}

// The three supported languages. English is the default; missing keys fall back
// to English (see i18n.ts). Labels are shown in their own language, as in the SI
// Console / Admin Portal language selector.
export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { value: "en", label: "English (US)" },
  { value: "pt", label: "Português (BR)" },
  { value: "es", label: "Español (ES)" },
];

/**
 * Maps an i18next language code to its dayjs / MUI-X locale. Our "pt" is
 * Brazilian Portuguese (label "Português (BR)"), so its dates use "pt-br"; the
 * i18next code and shared cookie value stay "pt" for cross-console sync.
 */
export function toDayjsLocale(language: string): string {
  return language === "pt" ? "pt-br" : language;
}
